<template lang="pug">
div
  b {{ `#${item.id}` }}
  span  {{ item.title }}
</template>

<script>
export default {
  props: {
    item: { required: true },
    searchText: { required: true },
  },
}
</script>
